module.exports = __webpack_public_path__ + "img/manager_icon.9ee05df.svg";